import {
  CONTROLLER,
  REQUIREMENTS,
  REQUIREMENT_GROUP_ID
} from '../routes'
import { Hyperlink } from '@eggplant/pattern-library'
import type { Props } from '../types'

const base = '/' + CONTROLLER + '/' + REQUIREMENTS + '?' + REQUIREMENT_GROUP_ID

interface Params {
  requirement_group_id: string
  requirement_id?: string
  test_case_uuids?: string
  isExternal?: boolean
}

const LinkToRequirementGroup = ({
  children,
  isExternal = true,
  requirement_group_id,
  requirement_id,
  test_case_uuids
}: (Props & Params)) => {
  const withRequirementID = requirement_id
    ? '&requirement_id=' + requirement_id
    : ''

  const withTestCase = test_case_uuids
    ? '&test_case_uuids=' + test_case_uuids
    : ''

  const baseURL = base + '=' + requirement_group_id + withRequirementID + withTestCase

  return (
    <Hyperlink
      href={baseURL}
      isExternal={isExternal}
    >
      {children}
    </Hyperlink>
  )
}

export default LinkToRequirementGroup
